import { useEffect } from 'react';

import { areSetsEqual } from '@paragon/client-tools';

import { syncClient } from '../store';
import { stationsSlice } from '../store/stationsSlice';
import { useAppSelector } from './hooks';

export function SyncClientManager() {
  const knownStationGuids = useAppSelector((state) => new Set(Object.keys(state.stations.stations)), areSetsEqual);

  useEffect(() => {
    syncClient.whenReady.then(() => {
      syncClient.state.configurations = Array.from(knownStationGuids).map((stationGuid) => ({
        room: `#station-${stationGuid}`,
        synchronizedActions: [stationsSlice.actions.loadStation.type],
      }));
    });
  }, [knownStationGuids]);

  return null;
}
